var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThermo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 52.833,
    height: 63.434,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1942",
    "data-name": "Groupe 1942",
    transform: "translate(-1048 -8631)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 53,
    cy: 53,
    r: 53,
    transform: "translate(1048 8631)",
    fill: "#d4b993"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1940",
    "data-name": "Groupe 1940",
    transform: "translate(3.159 2.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1930",
    "data-name": "Groupe 1930",
    transform: "translate(1072.423 8645.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1929",
    "data-name": "Groupe 1929",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_712",
    "data-name": "Trac\\xE9 712",
    d: "M9.711,126.651a9.71,9.71,0,0,1-5.3-17.844V80.826a5.3,5.3,0,0,1,10.609,0v27.981a9.71,9.71,0,0,1-5.3,17.844m0-49.012a3.19,3.19,0,0,0-3.186,3.186V109.4a1.059,1.059,0,0,1-.538.922,7.593,7.593,0,1,0,7.45,0,1.059,1.059,0,0,1-.538-.922V80.826a3.19,3.19,0,0,0-3.186-3.186",
    transform: "translate(0 -63.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_713",
    "data-name": "Trac\\xE9 713",
    d: "M54.164,140.374a1.059,1.059,0,0,1-1.059-1.059V107.307a1.059,1.059,0,0,1,2.118,0v32.008a1.059,1.059,0,0,1-1.059,1.059",
    transform: "translate(-44.453 -88.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_714",
    "data-name": "Trac\\xE9 714",
    d: "M17.5,17.323a1.059,1.059,0,0,1-.911-.518L14.04,12.512a1.059,1.059,0,1,1,1.821-1.082l2.552,4.293a1.059,1.059,0,0,1-.909,1.6",
    transform: "translate(-11.628 -9.134)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_715",
    "data-name": "Trac\\xE9 715",
    d: "M79.654,17.323a1.059,1.059,0,0,1-.909-1.6L81.3,11.43a1.059,1.059,0,1,1,1.821,1.082l-2.551,4.293a1.058,1.058,0,0,1-.911.518",
    transform: "translate(-65.791 -9.134)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_716",
    "data-name": "Trac\\xE9 716",
    d: "M55.133,8.189A1.059,1.059,0,0,1,54.074,7.13V1.059a1.059,1.059,0,1,1,2.118,0V7.13a1.059,1.059,0,0,1-1.059,1.059",
    transform: "translate(-45.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_717",
    "data-name": "Trac\\xE9 717",
    d: "M94.277,128.75a24.856,24.856,0,0,1-11.715-2.934,1.059,1.059,0,1,1,1-1.866,22.7,22.7,0,1,0-2.721-38.308,1.059,1.059,0,0,1-1.255-1.706,24.815,24.815,0,1,1,14.69,44.815",
    transform: "translate(-66.258 -66.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_718",
    "data-name": "Trac\\xE9 718",
    d: "M155.118,148.754v-5.715l-6.107-3.227-2.374-4.453.815-5.741h8.631l1.755-1.61-.272-.89-3.74-.662-4.7,1.579-1.631-7.747,3.722-.674,2.472-.337v-2.349l3.787-5.461.793.336a29.407,29.407,0,0,0,4.018,1.424,29.837,29.837,0,0,0,1.3-4.191l2.058.5c-1.267,5.185-1.991,5.527-2.38,5.711-.331.157-1,.473-5.026-1.165l-2.432,3.507v3.536l-4.281.583-1.51.274.691,3.286,2.953-.993,5.55.983,1.04,3.407-3.346,3.07h-7.617l-.459,3.236,1.744,3.27,6.661,3.52v4.259l2.845-.733,2.542-5.932-2.293-6.725,3.757-5.38,7.072.332,2.266-1.775,1.306,1.668-2.886,2.26-6.691-.313-2.473,3.541,2.209,6.479-3.272,7.637Z",
    transform: "translate(-122.745 -91.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_719",
    "data-name": "Trac\\xE9 719",
    d: "M45.862,312.519a3.322,3.322,0,1,1-3.322-3.322,3.321,3.321,0,0,1,3.322,3.322",
    transform: "translate(-32.829 -258.819)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermo);
export default __webpack_public_path__ + "static/media/thermo.314d6b0c02341cb963f40714869b20a4.svg";
export { ForwardRef as ReactComponent };